import { useEffect } from 'react';

/**
 * Shows or hides the busy cursor across the whole page while the app is loading.
 * Sets the document body cursor to progress when loading and back to auto otherwise.
 *
 * @param isLoading - Whether the page is currently loading.
 * @returns Nothing.
 */
const toggleLoadingCursor = (isLoading: any) => {
  if (isLoading) {
    document.body.style.cursor = 'progress';
  } else {
    document.body.style.cursor = 'auto';
  }
};

/**
 * Drives the busy cursor for the full-page loader from the given loading text. Turns the loading cursor on when text is present, off when it is empty, and off again on unmount so a route change cannot leave the cursor stuck.
 *
 * @param loadingText - The current loading text, supplied by the caller (e.g. read from a global store).
 * @returns The loading text, unchanged.
 */
export const useLoadingPage = (loadingText: string | undefined) => {
  useEffect(() => {
    if (loadingText) {
      toggleLoadingCursor(true);
    } else {
      toggleLoadingCursor(false);
    }

    // *: Hide loading cursor when navigating to new route (e.g. from Login page to inside pages)
    return () => {
      toggleLoadingCursor(false);
    };
  }, [loadingText]);

  // TODO: (In the future) Prevent selecting from user but keep loading cursor
  // useEffect(() => {
  //   const appElements = document.getElementsByClassName('app');
  //   if (appElements?.length) {
  //     document.body.style.cursor = 'progress';

  //     appElements[0].style.pointerEvents = 'none';
  //     appElements[0].style.userSelect = 'none';
  //   }
  // }, []);

  return { loadingText };
};
